import { Box, Paper, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const EXAMPLE = [
  { file: 'pigtails.png', roleId: 'avatarStudio.layerRole.skin' },
  { file: 'pigtails_O.png', roleId: 'avatarStudio.layerRole.outline' },
  { file: 'pigtails_SD.png', roleId: 'avatarStudio.layerRole.shadow' },
]

export default function EmptySectionHelp() {
  const { formatMessage } = useIntl()

  return (
    <Paper variant="outlined" sx={{ p: 3, maxWidth: 520 }}>
      <Stack spacing={2}>
        <Typography variant="subtitle1">
          {formatMessage({ id: 'avatarStudio.emptySection.title' })}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {formatMessage({ id: 'avatarStudio.emptySection.body' })}
        </Typography>
        <Box
          component="dl"
          sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 1, m: 0 }}
        >
          {EXAMPLE.map(({ file, roleId }) => (
            <React.Fragment key={file}>
              <Box
                component="dt"
                translate="no"
                sx={{ fontFamily: 'monospace', fontSize: 13 }}
              >
                {file}
              </Box>
              <Box component="dd" sx={{ m: 0, color: 'text.secondary', fontSize: 13 }}>
                {formatMessage({ id: roleId })}
              </Box>
            </React.Fragment>
          ))}
        </Box>
      </Stack>
    </Paper>
  )
}
